import { render, staticRenderFns } from "./ProductDetail.vue?vue&type=template&id=aeb5921c&scoped=true"
import script from "./ProductDetail.vue?vue&type=script&lang=js"
export * from "./ProductDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductDetail.vue?vue&type=style&index=0&id=aeb5921c&prod&lang=scss&scoped=true"
import style1 from "./ProductDetail.vue?vue&type=style&index=1&id=aeb5921c&prod&lang=scss&scoped=true"
import style2 from "./ProductDetail.vue?vue&type=style&index=2&id=aeb5921c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb5921c",
  null
  
)

export default component.exports